import styled from 'styled-components';

const conditionalAlign = props =>
	props.align
		? `align-items: ${props.align};`
		: null;

const conditionalJustify = props =>
	props.justify
		? `justify-content: ${props.justify};`
		: null;

const FlexRow = styled.div`
	display: flex;
	${conditionalAlign}
	${conditionalJustify}
	flex-wrap: ${props => props.noWrap ? 'no-wrap' : 'wrap'};

	@media (max-width: 1023px) {
		margin-left: -25px;
		margin-right: -25px;
	}
`;

export default FlexRow;
